export default __webpack_public_path__ + "cra_logo.7b33cd7f.png";